let registeredTokenGetter = null;

export function setRegisteredAccessTokenGetter(fn) {
  registeredTokenGetter = typeof fn === 'function' ? fn : null;
}

export async function resolveRegisteredAccessToken() {
  if (typeof registeredTokenGetter !== 'function') return null;
  try {
    return (await registeredTokenGetter()) || null;
  } catch {
    return null;
  }
}
